import React, { useEffect, useState, useCallback } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Box, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Para redirigir al formulario de nueva receta
import { ApiRequest } from '../../services/api'; // Ajusta la ruta según tu estructura
import CustomRecipeTableRow from './CustomRecipeTableRow';
import Loading from '../HelperElements/Loader/Loading';
import './Receta.css';

function RecipeList() {
  const [recipes, setRecipes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate(); // Hook para la navegación
  const [isLoading, setIsLoading] = useState(true);

  const loadRecipes = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await ApiRequest("api/Recetas/GetRecetasCms");
      const sortedData = [...(data || [])].sort((a, b) =>
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      );
      setRecipes(sortedData);
    } catch (error) {
      console.error("Error fetching recetas:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRecipes();
  }, [loadRecipes]);

  // Función para normalizar texto de búsqueda
  const normalizeText = (text) =>
    text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  // Filtrar recetas
  const filteredRecipes = recipes.filter(recipe =>
    normalizeText(recipe.nombre).includes(normalizeText(searchTerm))
  );

  // Función para redirigir al formulario de creación de receta
  const handleAddNew = () => {
    navigate('/Dashboard/Recetas/New'); // Ajusta la ruta al formulario de nueva receta
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Recetas
      </Typography>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Loading />
        </Box>
      ) : (
        <>


          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            gap: 2
          }}>
            <div class="contenedor-busqueda">
              <input
                placeholder="Buscar receta"
                id="input"
                class="busqueda-input"
                name="text"
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{ flex: 1, maxWidth: 400 }}
              />
              <label class="etiqueta-busqueda" for="input">
                <svg class="icono-busqueda" viewBox="0 0 512 512">
                  <path
                    d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                  ></path>
                </svg>
              </label>
            </div>

            <Button class="button" variant="contained" color="primary" onClick={handleAddNew}>
              Nuevo<svg fill="currentColor" viewBox="0 0 24 24" class="icon">
                <path
                  clip-rule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Estatus</TableCell>
                  <TableCell>Imagen</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRecipes.map((recipe, index) => (
                  <CustomRecipeTableRow key={index} item={recipe} onDeleteSuccess={loadRecipes}/>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Mensaje sin resultados */}
          {filteredRecipes.length === 0 && (
            <Typography variant="body1" sx={{
              mt: 2,
              textAlign: 'center',
              color: '#9e9e9e',
              fontStyle: 'italic'
            }}>
              No se encontraron recetas
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}

export default RecipeList;
